<script setup lang="ts">
import { computed } from 'vue'
import { useTheme } from 'vuetify'

import { SafeYoutubeColors } from '@kidzonet/consts/src/PolicyColors'

import IconWrapper from './BaseIcon.vue'

const theme = useTheme()

const iconColor = computed(
    () => theme.global.current.value.dark
        ? SafeYoutubeColors.icon.dark
        : SafeYoutubeColors.icon.light,
)
const backgroundColor = computed(
    () => theme.global.current.value.dark
        ? SafeYoutubeColors.background.dark
        : SafeYoutubeColors.background.light,
)
</script>

<template>
    <IconWrapper
        :style="{ backgroundColor }"
    >
        <v-icon
            icon="PolicyIconSafeYouTube"
            :color="iconColor"
            size="24"
        />
    </IconWrapper>
</template>
